import {
  EdgeLabelRenderer,
  BaseEdge,
  useReactFlow,
  getSmoothStepPath,
} from "@xyflow/react";
import { useWorkflowBuilder } from "../index2";

export function CustomEdge(props) {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data,
  } = props;
  const { getEdge } = useReactFlow();
  const edge = getEdge(id);
  const { openPanel } = useWorkflowBuilder();

  const [edgePath, labelX, labelY, offsetX, offsetY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Label adjusted for branches i.e edges having the same source node
  const adjustedLabelX = labelX > 60 ? labelX + offsetX : labelX - offsetX;

  return (
    <>
      <BaseEdge path={edgePath} />
      <EdgeLabelRenderer>
        <div className="nodrag nopan">
          <div 
            className={`absolute pointer-events-auto `}
            style={{
              transform: `translate(-50%, -100%) translate(${adjustedLabelX}px,${
                labelY + 48
              }px)`,
            }}
          >
            {data?.value}
          </div>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
